<aside class="tj-main__sidebar tj-post-sidebar">
  <div
    id="search-2"
    class="tj-sidebar__widget tj-sidebar-widget widget_search"
  >
    <h5 class="tj-sidebar-widget-title">Buscar</h5>
    <div class="tj-widget__search sidebar-search">
      <form
        (submit)="onSearchEvent($event)"
      >
        <input
          type="search"
          value=""
          required=""
          name="s"
          placeholder="Buscar..."
          [(ngModel)]="query"
          (ngModelChange)="query === '' && onSearch.emit('')"
        >
        <button type="submit"> <i class="material-symbols-outlined">search</i> </button>
      </form>
    </div>
  </div>

  <div
    id="tj-category-widget-2"
    class="tj-sidebar__widget tj-sidebar-widget tj_category_widget"
  >
    <h5 class="tj-sidebar-widget-title">Buscar por</h5>
    <div class="tj_widget_categories wp-cat">
      <ul>
        <li class="relative mb-5 transition-all duration-400 ease-in-out z-[1]"
            [class.bg-secondary!]="category() === 'collaborator'">
          <a [routerLink]="['/advisors/collaborator']"
             class="flex items-center justify-between w-full px-6 py-[15px] font-heading font-bold text-base text-heading-primary transition-colors duration-400"
             [class.text-white!]="category() === 'collaborator'">
            Colabs </a>
        </li>
        <li class="relative mb-5 transition-all duration-400 ease-in-out z-[1]"
            [class.bg-secondary!]="category() === 'expert'">
          <a [routerLink]="['/advisors/expert']"
             class="flex items-center justify-between w-full px-6 py-[15px] font-heading font-bold text-base text-heading-primary transition-colors duration-400"
             [class.text-white!]="category() === 'expert'">
            Experts </a>
        </li>
        <li class="relative mb-5 transition-all duration-400 ease-in-out z-[1]"
            [class.bg-secondary!]="category() === 'ies'">
          <a [routerLink]="['/advisors/ies']"
             class="flex items-center justify-between w-full px-6 py-[15px] font-heading font-bold text-base text-heading-primary transition-colors duration-400"
             [class.text-white!]="category() === 'ies'">
            Asesores </a>
        </li>
      </ul>
    </div>
  </div>

  <div class="tj-sidebar__widget tj-sidebar-widget widget_tag_cloud">
    <h5 class="tj-sidebar-widget-title">Tags</h5>
    <nav aria-label="Tags">
      <div class="tagcloud">
        @if (tags()) {
        @for (tag of tags().slice(0, showMoreTags() ? tags().length : 15); track $index) {
          <a
            (click)="handleSelectedTag(tag)"
            [class.bg-secondary!]="selectedTag() === tag.id || isInitialTag()(tag.slug)"
            [class.text-white!]="selectedTag() === tag.id || isInitialTag()(tag.slug)"
            rel="tag"
            class="lowercase text-xs! transition-all ease-in-out cursor-pointer"
          >{{ tag.title }}</a>
        }
        }
      </div>

      @if (tags().length > 15 && !showMoreTags()) {
        <a (click)="showMoreTags.set(!showMoreTags())" 
        class="
          w-fit relative underline-effect before:bg-heading-primary! 
          lowercase text-xs! text-heading-primary font-semibold
          flex items-center gap-1 mt-4
          cursor-pointer
        ">
          Ver más
          <i class="material-symbols-outlined text-base! font-semibold">arrow_right_alt</i>
        </a>
      }
    </nav>
  </div>
</aside>